import PropTypes from 'prop-types';
import React, {
  useState,
} from 'react';

import { Map, Iterable } from 'immutable';

import Button      from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Grid        from '@mui/material/Grid';

import Display from 'components/Generic/Display';
import Audio   from 'components/Generic/Inputs/Audio';
import Text    from 'components/Generic/Inputs/Text';

function AudioText({ name, value, onChange }) {
  const [state, setState] = useState(new Map());

  const mode = state.get('mode', 'audio');

  function setMode(md) {
    setState(state.set('mode', md));
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <ButtonGroup color="primary" aria-label="primary button group">
          <Button variant={mode === 'audio' ? 'contained' : 'outlined'} onClick={() => setMode('audio')}>{t('eos.landing_page.label.audio')}</Button>
          <Button variant={mode === 'text' ? 'contained' : 'outlined'} onClick={() => setMode('text')}>{t('eos.landing_page.label.text')}</Button>
        </ButtonGroup>
      </Grid>
      <Grid item xs={12}>
        <Display if={mode === 'audio'}>
          <Audio
            name={name}
            value={value}
            onChange={onChange}
          />
        </Display>
        <Display if={mode === 'text'}>
          <Text
            name={name}
            value={value}
            onChange={onChange}
          />
        </Display>
      </Grid>
    </Grid>
  );
}

AudioText.defaultProps = {
  name:     null,
  value:    null,
  onChange: null,
};

AudioText.propTypes = {
  name:     PropTypes.string,
  value:    PropTypes.objectOf(Iterable),
  onChange: PropTypes.func,
};

export default AudioText;
